import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'antd';
import styles from './index.module.less';
import { IWheelRef, Wheel } from '@base/common/Wheel/Wheel'
import { IPrize, IWheelConfig } from '@base/common/Wheel/interface'
import { IDrawResultCoupon, IWheelConfigData } from '@base/activity/CouponDrawWheel/interface'
import cn from 'classnames';
import { Button } from '@base/lib/Button';
import { isPhone } from 'base/utils/client';
import dayjs from 'dayjs';
import { useStore } from 'base/store'
import { RouteEnum } from 'pro/config/routers'
import { generatePath } from 'ava-util/dist/request';
import { useRouter } from 'next/router';
import Iconfont from '@base/lib/Iconfont'
import { useTrans } from 'base/utils/i18n'
import site from 'pro/config/site'
import Image from '@base/lib/ThemeImage'

type IProps = {
    visible: boolean;
    onClose: () => void;
    wheelConfig?: IWheelConfigData;
    result?: IDrawResultCoupon;
}


const RewardInfo1: React.FC<{ targetReward?: IDrawResultCoupon }> = ({ targetReward }) => {
    return (
        <>

            <p className={'g-more-title text-primary'}>
                {/*APP Exclusive*/}
                {targetReward?.appTag}
            </p>

            <p className={'g-more-time'}>
                {targetReward?.couponStartTime && dayjs(targetReward.couponStartTime * 1000).format('MMM DD, YYYY hh:mm A')}
                <span>&nbsp;-&nbsp;</span>
                {targetReward?.couponEndTime && dayjs(targetReward.couponEndTime * 1000).format('MMM DD, YYYY hh:mm A')}
            </p>
        </>
    )
}

const RewardPcQr: React.FC = () => {
    const { t } = useTrans();
    return (
        <div className="g-scan-wrap">
            <p className={"g-scan-msg text-center"}>
                {t('web_scan_download_app_info_1')}
            </p>

            <div className="grid-qr flex flex-middle flex-justify">
                <div className={"g-qr-image flex-1"}>
                    <Image
                        src="file-asset/file/a7bfb89a030a095907cbecab366bca71.svg"
                        width={120}
                        fixed
                        background={false}
                    />
                </div>

                <div className={"g-app-warp flex-1 flex flex-vertical flex-middle flex-justify"}>
                    <div className={"g-item flex-1 flex flex-middle flex-justify"}>
                        <Iconfont className="icon-Android text-primary"/>
                        <span className={"flex-1"}>{t('web_common_android')}</span>
                    </div>
                    <div className={"g-item flex-1 flex flex-middle flex-justify"}>
                        <Iconfont className="icon-iphone text-primary"/>
                        <span className={"flex-1"}>{t('web_common_iphone')}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}


const RewardModal: React.FC<IProps> = (props) => {
    const {
        visible,
        wheelConfig,
        onClose,
        result,
    } = props;

    const WHEEL_CONFIG: IWheelConfig = {
        width: isPhone ? 275 : 370,
        height: isPhone ? 275 : 370,
        fontSize1: isPhone ? 16 : 22,
        fontSize2: isPhone ? 12 : 14,
        backgroundColor: "#4E5559",
        textColor: '#ffffff',
        pointerColor: '#4E5559',
        // pointerColor: '#05DA54',
    }

    const router = useRouter();
    const { userStore } = useStore();
    const isLogin = userStore.checkAuth();
    const { t } = useTrans();

    let { rewards = [] } = wheelConfig || {}

    const targetReward = result || wheelConfig?.drawResultCoupon

    rewards = rewards.map((item) => {
        return {
            ...item,
            color: targetReward?.uniqueId === item.uniqueId ? item.color : '#949494',
        }
    }) || [];

    // 找到中奖下标
    const resultIndex = rewards.findIndex((item) => item.uniqueId === targetReward?.uniqueId);
    // Refs
    const canvasRef = useRef<IWheelRef>(null);

    useEffect(() => {
        if (visible && targetReward) {
            setTimeout(() => {
                canvasRef.current?.reset(resultIndex)
            }, 20)
        }
    }, [visible, targetReward]);

    return (
        <Modal
            transitionName={""}     // 关闭 modal 动画
            maskTransitionName={""} // 关闭 modal 动画
            destroyOnClose
            open={visible}
            footer={null}
            className={styles['modal-popup']}
            centered
            onCancel={onClose}
            closable={false}
            maskClosable={false}
            maskStyle={{
                background: 'rgba(0, 0, 0, 0.9)'
            }}
        >
            <div className={cn(styles['reward-container'])}>

                <p className={cn(styles['title'], 'text-center')}>
                    {t('web_spin_congratulations')}
                </p>

                <Wheel
                    ref={canvasRef}
                    wheelConfig={WHEEL_CONFIG}
                    prizes={rewards}
                />

                <div
                    className={cn(
                        styles['card-container'],
                        "flex flex-center flex-middle"
                    )}
                >
                    <div className={cn(styles['card-wrap'])}>
                        <div className={'text-center'}>
                            <p className={'g-title'}>{targetReward?.discount}</p>
                            <p className={'g-sub-title'}>Code:&nbsp;{targetReward?.couponCode}</p>
                        </div>

                        <div className={'g-more-info'}>
                            {isLogin ? (
                                <>
                                    {isPhone ? (
                                        <>
                                            <RewardInfo1 targetReward={targetReward}/>

                                            <p className={'g-more-msg'}>
                                                {t('web_spin_coupon_added')}
                                            </p>

                                            <Button
                                                className={'g-button'}
                                                size={isPhone ? 'small' : 'middle'}
                                                block={true}
                                                type={'primary'}
                                                target={'_blank'}
                                                href={site.appDownloadLink}
                                            >
                                                {t('web_spin_check_in_pp')}
                                            </Button>

                                        </>
                                    ) : (
                                        <RewardPcQr/>
                                    )}
                                </>
                            ) : (
                                <>
                                    <RewardInfo1 targetReward={targetReward}/>

                                    <Button
                                        className={'g-button'}
                                        size={isPhone ? 'small' : 'middle'}
                                        block={true}
                                        type={'primary'}
                                        href={generatePath(RouteEnum.LOGIN, { redirect: router.asPath })}
                                    >
                                        {t('web_spin_sign_in_to_claim')}
                                    </Button>
                                </>
                            )}
                        </div>
                    </div>

                    <div className={styles['tips-wrap']}>
                        {targetReward?.productScope}
                    </div>

                </div>

                <div
                    className={cn(styles['close-wrap'], 'flex flex-center')}
                >
                    <Iconfont
                        onClick={onClose}
                        className={cn('icon-x', 'pointer')}
                    />
                </div>
            </div>

        </Modal>
    );
};

export default RewardModal